/**
 * Created by Dmitry Eremin on 02.10.2026
 */

const VillageLocation = function (locationConfig, slot) {
    cleverapps.EventEmitter.call(this);

    this.locationConfig = locationConfig;
    this.locationId = locationConfig.locationId;
    this.slot = slot;

    const data = this.slot.load("village") || {};
    this.village = new Village(data.level || 0, { location: this, data });

    cleverapps.user.on("changeHard", () => this.village.checkAttention());
};

VillageLocation.prototype = Object.create(cleverapps.EventEmitter.prototype);
VillageLocation.prototype.constructor = VillageLocation;

VillageLocation.prototype.save = function () {
    this.slot.save("village", this.village.getInfo());
};

VillageLocation.prototype.moveNextVillage = function () {
    this.village = new Village(this.village.level + 1, { location: this });
    this.save();
};

VillageLocation.prototype.reset = function () {
    this.village = new Village(0, { location: this });
    this.save();
};

VillageLocation.GetMainScene = function () {
    return bundles.main.jsons.villagescene_prefab_json;
};

Meta.GetAvailableLocations = function () {
    return {
        "0": {
            id: 0,
            slotId: Meta.SLOT_MAIN,
            locationType: "village",
            retire: false
        }
    };
};

Meta.prototype.getLocationClass = cleverapps.extendFunc(Meta.prototype.getLocationClass, function (locationId) {
    if (this.getLocationMeta(Meta.ToCompatLocationId(locationId)).locationType === "village") {
        return VillageLocation;
    }

    return this._super(locationId);
});
